import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
export const SystemMessage = ({ message, goBackHref, reset }) => {
    const hasGoBack = !!goBackHref;
    const hasReset = !!reset;
    const hasActions = hasGoBack || hasReset;
    return (<Box display='flex' flexDirection='column' textAlign='center' mt={4} gap={3}>
			<Typography variant='h6' color='text.secondary' sx={{ fontWeight: 500 }}>
				{message}
			</Typography>

			{hasActions && (<Box display='flex' justifyContent='center' alignItems='center' gap={2} flexWrap='wrap'>
					{hasGoBack && (<Button component={Link} href={goBackHref} variant='outlined' size='medium'>
							Go back
						</Button>)}
					{hasGoBack && hasReset && (<Typography variant='body2' color='text.secondary'>
							or
						</Typography>)}
					{hasReset && (<Button onClick={reset} variant='outlined' size='medium'>
							Try again
						</Button>)}
				</Box>)}
		</Box>);
};
//# sourceMappingURL=SystemMessage.jsx.map